import React from 'react';
import { PropTypes } from "prop-types";

const NipInputSession = ({
    type,
    label,
    detail,
    placeholder,
    field,
    form,
    onChange,
    onBlur,
    name,
    onFocus,
    title2,
    value2,
    title3,
    value3
}) => {
    return (
        <div>
            <div className="nip-input-container">
                <label className="form-label">{label}</label>
                <p className="form-details">{detail}</p>
                <div className="form-input-wrap">
                    <input
                        type={type}
                        onFocus={onFocus}
                        placeholder={placeholder}
                        onChange={(field && field.onChange) || onChange}
                        onBlur={(field && field.onBlur) || onBlur}
                        value={(field && field.value) || ''}
                        name={(field && field.name) || name}
                        className="form-input"
                    />
                    <div className="form-disabled">
                        <span>{title2}</span>
                        <p>{value2}</p>
                    </div>
                    <div className="form-disabled">
                        <span>{title3}</span>
                        <p>{value3}</p>
                    </div>
                </div>
            </div>
            {form && form.touched[field.name] && form && form.errors[field.name] && (
                <small className="errors">{form.errors[field.name]}</small>
            )}
        </div>
    )
}

NipInputSession.propTypes = {
  detail: PropTypes.any,
  field: PropTypes.object,
  form: PropTypes.object,
  label: PropTypes.any,
  name: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  placeholder: PropTypes.string,
  title2: PropTypes.any,
  title3: PropTypes.any,
  type: PropTypes.string,
  value: PropTypes.string,
  value2: PropTypes.any,
  value3: PropTypes.any
}

export default NipInputSession;